import React from "react";
import { Link } from "react-router-dom";
import { STAGES } from "../data/stages";
import { formatDate } from "../utils/format";
import { weeklyApplications } from "../utils/jobs";

export function PipelineChart({ jobs }) {
  const counts = STAGES.map((s) => ({ ...s, count: jobs.filter((j) => j.stage === s.id).length }));
  const max = Math.max(1, ...counts.map((c) => c.count));

  return (
    <div className="d-flex flex-column gap-2">
      {counts.map((s) => (
        <Link key={s.id} to={`/tracker?stage=${s.id}`} className="pipeline-row" title={s.description}>
          <span className="pipeline-label">{s.label}</span>
          <span className="pipeline-track">
            <span
              className="pipeline-bar"
              style={{ width: `${(s.count / max) * 100}%`, background: s.color, minWidth: s.count ? 8 : 0 }}
            />
          </span>
          <span className="pipeline-count">{s.count}</span>
        </Link>
      ))}
    </div>
  );
}

export function WeeklyChart({ jobs }) {
  const weeks = weeklyApplications(jobs);
  const max = Math.max(1, ...weeks.map((w) => w.count));
  const total = weeks.reduce((sum, w) => sum + w.count, 0);

  return (
    <div>
      <div className="d-flex align-items-baseline gap-2 mb-3">
        <span className="fs-4 fw-semibold">{total}</span>
        <span className="text-muted small">applications in the last 8 weeks</span>
      </div>
      <div className="weekly-chart" role="img" aria-label={`${total} applications in the last 8 weeks`}>
        {weeks.map((w, i) => (
          <div key={i} className="weekly-col" title={`Week of ${formatDate(new Date(w.start).toISOString())}: ${w.count}`}>
            <span className="weekly-value">{w.count || ""}</span>
            <div className="weekly-bar" style={{ height: `${(w.count / max) * 100}%` }} />
            <span className="weekly-label">{formatDate(new Date(w.end).toISOString(), { month: "numeric", day: "numeric" })}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
